export const FORMS = [
  {
    section: 'Policy',
    access: ['policy'],
    forms: [
      {
        label: 'Consolidated Report',
        url: 'policy/consolidated_report',
        access: 'policy',
      },
    ],
  },
  {
    section: 'Claim',
    access: ['claim'],
    forms: [
      {
        label: 'Consolidated Report',
        url: 'claim/consolidated_report',
        access: 'claim',
      },
    ],
  },
];
